module.exports = __webpack_public_path__ + "static/media/facebook-circle-border.e328eea4.svg";